import Model from './Model'

export default class Registration extends Model {
    resource()
    {
        return 'registrations'
    }
}